export const REQUEST_RESULTS = "[results] REQUEST_RESULTS";
export const RECEIVE_RESULTS = "[results] RECEIVE_RESULTS";
export const RECEIVE_MORE_RESULTS = "[results] RECEIVE_MORE_RESULTS";
export const LOAD_MORE = "[results] LOAD_MORE";
